
export class Constants{
    public static ROOT_URL = 'https://api.dailylawdigest.com/v1/';
    public static ROOT_URL2 = 'https://api.dailylawdigest.com/v2/';
}
